module.exports = { apiServer: 'https://api-uat.azure.intimex.hk', AdminServer: 'https://admin-uat.azure.intimex.hk', env: 'prod' };
